import VariablePaymentType from "@/enums/VariablePaymentType";
import Vue from "vue";
import SalaryInfoModalHeader from "../SalaryInfoModalHeader.vue";
import DirectorVariableSalaryModal from "./Director/DirectorVariableSalaryModal.vue";
import FixedVaraiableSalaryModal from "./Fixed/FixedVariableSalaryModal.vue";
import InvalidVariableSalaryModal from "./Invalid/InvalidVariableSalaryModal.vue";
import LevelVariableSalaryModal from "./Level/LevelVariableSalaryModal.vue";
import TeamManagerVariableSalaryModal from "./TeamManager/TeamManagerVariableSalaryModal.vue";
export default Vue.extend({
    props: {
        selectedDate: String,
        salaryRow: {},
    },
    components: {
        SalaryInfoModalHeader,
    },
    computed: {
        detailsComponent() {
            switch (this.salaryRow.paymentType) {
                case VariablePaymentType.Director:
                    return DirectorVariableSalaryModal;
                case VariablePaymentType.TeamManager:
                    return TeamManagerVariableSalaryModal;
                case VariablePaymentType.Fixed:
                    return FixedVaraiableSalaryModal;
                case VariablePaymentType.Level:
                    return LevelVariableSalaryModal;
                default:
                    return InvalidVariableSalaryModal;
            }
        },
    },
});
